var _this = this;
import { jsx as _jsx } from "react/jsx-runtime";
//to remove the white space
export const normalizeInput = value => {
  var _a;
  return (_a = value === null || value === void 0 ? void 0 : value.replace(',', '')) === null || _a === void 0 ? void 0 : _a.replace(/\s/g, '');
};
//to remove the escape chars
const escapeForRegex = value => {
  return value === null || value === void 0 ? void 0 : value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
//to fiter out the IList type
export const isValidMatch = (option, value, grouped) => grouped && normalizeInput((option === null || option === void 0 ? void 0 : option.group) || '').search(new RegExp(normalizeInput(escapeForRegex(value)), 'i')) !== -1 || normalizeInput((option === null || option === void 0 ? void 0 : option.value) || '').search(new RegExp(normalizeInput(escapeForRegex(value)), 'i')) !== -1 || normalizeInput((option === null || option === void 0 ? void 0 : option.secondary) || '').search(new RegExp(normalizeInput(escapeForRegex(value)), 'i')) !== -1;
//to filter given options (array object) w.r.t typed input
export const getSuggestions = (options, maxsuggestions, value, grouped) => {
  var _a;
  return (_a = options === null || options === void 0 ? void 0 : options.map(option => typeof option === 'object' ? option : {
    value: option
  })) === null || _a === void 0 ? void 0 : _a.filter(option => {
    return isValidMatch(option, value, grouped);
  }).slice(0, maxsuggestions); // Limit results
};
//implementation makinput
export const markMatch = (value, matches, idx) => {
  if (!matches.length) {
    return value;
  }
  const m = matches.pop();
  const parts = value.split(new RegExp(m), -1).map(p => markMatch(p, matches));
  return parts.map((p, i) => [p, i < parts.length - 1 ? _jsx("strong", {
    children: m
  }, idx) : '']);
};
//final fitered options for typeahead to render suggested or options list
export const callSetSuggestion = (options, grouped, maxsuggestions, value, inputText, noresult) => {
  let suggestions = getSuggestions(options, maxsuggestions, value, grouped);
  if (suggestions.length === 0) {
    suggestions = [];
    if (noresult) {
      suggestions.push({
        error: 'NO_RESULT',
        text: noresult
      });
    }
  }
  if (suggestions.length === 1 && suggestions[0].value !== value || suggestions.length > 1) {
    return suggestions;
  } else if (suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(inputText)) {
    return suggestions;
  } else return suggestions;
};
//const var for max suggestion
export const MAX_MATCHES = 10;
//initial max suggestion
export const getmaxsuggestions = maxsuggestions => {
  return !isNaN(maxsuggestions) && maxsuggestions > 0 ? maxsuggestions : MAX_MATCHES;
};
//simple debounce method to accept call back with delay
export const debounce = function (func) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  let timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(_this, args);
    }, delay);
  };
};